import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import isEqual from 'lodash-es/isEqual';

const CssTextField = withStyles({
  root: {
    width: '100%',

    '& label.Mui-focused': {
      color: '#4F4F4F'
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#00AAFC'
      }
    },
    '& .MuiFormHelperText-root': {
      color: 'red'
    }
  }
})(TextField);

/**
 * Outlined Input: full width outlined input, customized from mui. API: https://material-ui.com/api/outlined-input/
 */
export default React.memo(
  function OutlinedInput(props: TextFieldProps) {
    return <CssTextField {...props} margin="normal" variant="outlined" />;
  },
  (prevProps, nextProps) =>
    isEqual(prevProps.value, nextProps.value) && isEqual(prevProps.error, nextProps.error)
);
